/// <reference path="../_references.ts"/>

module App.WorkOrder {

	export class BannerService {

		banner: Banner;

		constructor(private $http: ng.IHttpService,
					private $window: ng.IWindowService,
					private $timeout: ng.ITimeoutService,
					public Constants: IConstants) {

		}

		public getBannerProperty(banner: Banner, prop: string): string {
			let value: string = null;

			if (banner) {
				switch(prop) {
					case 'color' :
						value = banner.color;
						break;
					case 'text' :
						value = banner.text;
						break;
					default:
					// nothing;
				}
			}

			return value;
		}

		public getPackageBanners(): ng.IHttpPromise<Banner[]> {
			const vm = this;

			return vm.$http.get(`${vm.Constants.apiUrl}packagebanner`);
		}

		public triggerResizeEvent() {
			const vm = this;

			vm.$timeout(() => {
				vm.$window.dispatchEvent(new Event('resize'));
			}, 100);
		}

		public static Factory() {
			let instance = ($http: ng.IHttpService, $window: ng.IWindowService, $timeout: ng.ITimeoutService, Constants: IConstants) => {
				return new BannerService($http, $window, $timeout, Constants);
			};

			instance.$inject = ['$http', '$window', '$timeout', 'Constants'];

			return instance;

		}
	}
}
